import Vue from 'vue';
import moment from 'moment';
import salesReportTransformer from './../../transformers/salesReport';

const success = ({ data }, resolve) => {
  const report = salesReportTransformer.fetchCollection(data.data);

  resolve(report);
};

const failed = (error, reject) => reject(error);


export default (group, dateRange, filter, type) => (
  new Promise((resolve, reject) => {
    let url = '/reports/sales';
    const query = [];
    if (group !== undefined) {
      query.push(`group_by=${group}`);
    }

    if (type !== undefined) {
      query.push(`type=${type}`);
    }

    if (filter !== undefined) {
      query.push(`filter=${filter}`);
    }

    if (dateRange[0] && dateRange[1]) {
      query.push(`start=${moment(dateRange[0]).format('YYYY-MM-DD')}`);
      query.push(`end=${moment(dateRange[1]).format('YYYY-MM-DD')}`);
    }

    if (query.length > 0) {
      url += '?';
      query.map((q) => {
        url += `${q}&`;
        return q;
      });
      url = url.substring(0, url.length - 1);
    }

    Vue.$http.get(url)
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/report/sales.js